import axios from 'axios'
import { Toast } from 'vant'
import Router from '@/router'
import store from '@/store'
export let baseURL = ''
if (process.env.NODE_ENV === 'ys_dev') {
  baseURL = 'http://ysclass.net'
} else if (process.env.NODE_ENV === '96_dev') {
  baseURL = 'http://192.168.38.96:10103'
} else if (process.env.NODE_ENV === '200_dev') {
  baseURL = 'http://192.168.38.200'
} else if (process.env.NODE_ENV === 'sc_jky_dev') {
  // baseURL = 'http://47.108.30.203'
  baseURL = 'https://wljy.scsjky.cn'
} else if (process.env.NODE_ENV === 'gx_jky_dev') {
  baseURL = 'http://8.134.78.207'
}
const instance = axios.create({
  baseURL,
  timeout: 100000
})
// 500 登录
// request拦截器 request interceptor
instance.interceptors.request.use(
  config => {
    if (!config.hideloading) {
      Toast.loading({
        forbidClick: true
      })
    }
    if (!config.hideToken) {
      const token = localStorage.getItem('Authorization')
      config.headers.Authorization = token
    }
    const tenantId = store.state.tenantId
    if (tenantId && store.state.openTenant === 1) {
      config.headers.tenantId = tenantId
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
// respone拦截器
instance.interceptors.response.use(
  res => {
    Toast.clear()
    if (res.status && res.status === 200) {
      const code = res.data.code
      if (code === 0) {
        return Promise.resolve(res.data)
      } else {
        if (code === 401) {
          localStorage.clear()
        } else if (code === 500) {
          console.log(`500:${res.data.msg}`)
          return Toast.fail({
            message: `${res.data.msg}`,
            duration: 2000
          })
        }
        if (res.config.url.indexOf('oss') !== -1 || res.config.url.indexOf('signup/checkPhone') !== -1) {
          return Promise.resolve(res)
        }

        if (code === 404) {
          return Promise.reject(res || 'error')
        }
        if (code === 403) {
          // Router.replace('/401')
          // return Promise.reject(res || 'error')
        }
      }
    } else {
      return Promise.reject(res || 'error')
    }
  }
  ,
  error => {
    Toast.clear()
    const response = error.response
    if (response && response.status === 500) {
      Toast.fail({
        message: `500:${response.data.msg}`,
        duration: 2000
      })
    }
    if (response && response.status === 401) {
      localStorage.clear()
    }
    if (response && response.status === 403) {
      Router.replace('/401')
    }
    return Promise.reject(error)
  }
)

export default instance
